import { render, staticRenderFns } from "./SingleOffre.vue?vue&type=template&id=488ddb22&"
import script from "./SingleOffre.vue?vue&type=script&lang=js&"
export * from "./SingleOffre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports